<template>
  <BaseTable
    class="custom-table"
    tableClass="table-bordered"
    hidePagination
  >
    <template #thead>
      <thead>
        <tr>
          <th style="width: 190px;">{{ $t('apps.billing.label.date') }} UTC</th>
          <th style="width: 150px;">{{ $t('apps.billing.label.detail') }}</th>
          <th class="text-center">{{ $t('apps.billing.label.quantity') }} ({{ $t('apps.billing.label.used') }})</th>
          <th class="text-center">{{ $t('apps.billing.label.duration') }} ({{ $t('apps.billing.label.unithours') }})</th>
          <th class="text-center">{{ $t('apps.billing.label.unitprice') }}</th>
          <th
            style="width: 140px;"
            class="text-right">{{ $t('apps.billing.label.payamount') }}</th>
        </tr>
      </thead>
    </template>
    <template #tbody>
      <tbody>
        <tr>
          <td
            v-if="!items.length"
            colspan="6"
            class="text-center">
            {{ $t('message.notfounddata') }}
          </td>
        </tr>
        <tr
          v-for="(item, index) in items"
          :key="index"
        >
          <td>
            {{ getDateTimeUTC(item.createdAt) }}
          </td>
          <td>
            {{ $t('apps.billing.message.warehousecount') }}
          </td>
          <td class="text-center">
            {{ numberel(item.countTotal) }}
          </td>
          <td class="text-center">
            1
          </td>
          <td class="text-center">
            {{ $t('apps.billing.message.unitpricewarehouse', { number: item.amountPerUnit }) }}
          </td>
          <td class="text-right">
            {{ item.amountTotal }}
          </td>
        </tr>
      </tbody>
    </template>
  </BaseTable>
</template>

<script>
export default {
  props: {
    items: {
      required: true,
      type: Array,
      default: () => ([]),
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseTableUsegeWarehouse.vue